export default __webpack_public_path__ + "static/media/work3image3.44cd99de.png";